import * as React from 'react';
import classNames from 'styles/utils/classNames';

interface CoachStatCardProps {
  icon?: React.ReactNode;
  value: string | number;
  label: string;
  className?: string;
}

const CoachStatCard: React.FC<CoachStatCardProps> = ({ icon, value, label, className }) => {
  return (
    <div
      className={classNames(
        'bg-color-bg-lightmode-primary dark:bg-color-bg-darkmode-primary',
        'border border-color-border-input-lightmode dark:border-color-border-input-darkmode',
        'rounded-3xl shadow-sm',
        'p-6',
        'flex items-start justify-between',
        'relative',
        className,
      )}
    >
      {/* Icon Section */}
      {icon && <div className="flex-shrink-0">{icon}</div>}

      {/* Content Section */}
      <div className="flex flex-col items-start justify-end gap-3 text-right">
        {/* Value */}
        <div className="typography-product-heading-compact-desktop  text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
          {value}
        </div>

        {/* Label */}
        <div className="typography-product-chips-filters  text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
          {label}
        </div>
      </div>
    </div>
  );
};

export default CoachStatCard;
